import { Box, Container, Divider, Stack } from '@mui/material';
import { ReactNode, useState } from 'react';
import { Organisation } from '../../@types/organization';
import LoginForm from './components/LoginForm';
import { ContentStyle, RootStyle } from './components/Styles';
import SelectOrganization from './components/SelectOrganization';
import LoginGreeting from './components/LoginGreeting';
import { Button } from '@nps.today/component-library';
import useMicrosoftLogin from './components/useMicrosoftLogin';
import { Text } from 'components/text/Text';
import { useTranslator } from 'translation/useTranslator';

function MicrosoftLogo() {
  return (
    <img
      src={'/static/icons/ms-symbol.svg?react'}
      alt="Microsoft logo"
      width="100%"
      style={{ cursor: 'pointer', alignSelf: 'center' }}
    />
  );
}

type LoginProps = {
  showOnlyForm?: boolean;
};

export default function Login({ showOnlyForm }: Readonly<LoginProps>) {
  const translator = useTranslator();
  const [userOrganisations, setUserOrganisations] = useState<Organisation[]>([]);
  const { handleLoginWithMicrosoft, isMicrosoftSsoLoading } = useMicrosoftLogin({
    userOrganisations,
    setUserOrganisations
  });

  let loginForm: ReactNode;
  // If there are tenants to pick from, show the select organisation form
  if (userOrganisations.length >= 1) {
    loginForm = <SelectOrganization organisations={userOrganisations} />;
  } else {
    loginForm = (
      <>
        <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Text dataTestId="login-title" variant="h4" gutterBottom>
              {translator.signInToNpsToday()}
            </Text>
            <Text sx={{ color: 'text.secondary' }}>{translator.enterYourDetailsBelow()}</Text>
          </Box>
        </Stack>
        <LoginForm setUserOrganisations={setUserOrganisations} />

        <Divider sx={{ pt: 2, pb: 2 }}>
          <Text variant="body2">or</Text>
        </Divider>

        <Button
          dataTestId="login-with-microsoft"
          color={'secondary'}
          onClick={() => handleLoginWithMicrosoft()}
          fullWidth
          size="large"
          variant={'outlined'}
          startIcon={<MicrosoftLogo />}
          loading={isMicrosoftSsoLoading}
        >
          {translator.signInWithMicrosoft()}
        </Button>
      </>
    );
  }

  if (showOnlyForm) {
    return loginForm;
  }

  return (
    <RootStyle title="Login" disableHeader>
      <div style={{ display: 'flex' }}>
        <LoginGreeting />
        <Container maxWidth={userOrganisations.length < 1 ? 'sm' : false}>
          <ContentStyle>{loginForm}</ContentStyle>
        </Container>
      </div>
    </RootStyle>
  );
}
